"use client";

import Cookies from "js-cookie";

export const AccountName = () => Cookies.get("AccountName"); 
export const CompanyName = () => Cookies.get("CompanyName"); 
export const UserName = () => Cookies.get("UserName"); 
export const CDate = () => Cookies.get("cdate"); 
export const Ismail = () => Cookies.get("ismail"); 
export const Iswhatsapp = () => Cookies.get("iswhatsapp"); 
export const ISSms = () => Cookies.get("issms"); 
export const isactive = () => Cookies.get("isactive"); 
export const AccountId = (): number => {
  const value = Cookies.get("AccountId"); // string | undefined
  return value ? Number(value) : 0;       // convert to number, default 0
};

export const UserInfoUserId = (): number => {
  const value = Cookies.get("UserInfoUserId");
  return value ? Number(value) : 0;
};

 
export const authToken = () => Cookies.get("authToken");